import React, { useState, useEffect } from "react";
import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";
import banner from "../assets/imagen.jpg";
import { Row, Col } from "react-bootstrap";
import { Container, Image, Button } from "react-bootstrap";
import "../components/riesgos.css";
import SocialBar from "../components/SocialBar";
import { Link } from "react-router-dom";
import { FiAlertTriangle } from "react-icons/fi";
import { useSiteSettings } from '../hooks/useSiteSettings';
import fallbackBanner from '../assets/imagen.jpg';

const API_URL = "https://facach.coop.hn/api";

const FALLBACK = [
  { id: 1, titulo: "Matriz de Riesgos", subtitulo: "", descripcion: "Herramienta integral que permite identificar, evaluar y priorizar los riesgos.", accent_color: "#C94E64", bg_light: "#FFECEF" },
  { id: 2, titulo: "Marco Integral de Riesgos", subtitulo: "", descripcion: "Establece la estructura formal para la identificación y control de los riesgos.", accent_color: "#2E5AA7", bg_light: "#EAF1FF" },
  { id: 3, titulo: "Capacitación en Gestión de Riesgos", subtitulo: "", descripcion: "Impulsa una cultura organizacional orientada a la prevención y control.", accent_color: "#2E8B57", bg_light: "#EAF9F0" },
  { id: 4, titulo: "Asesoría Técnica", subtitulo: "", descripcion: "Acompañamiento especializado para el diseño y mejora de procesos de gestión.", accent_color: "#1A7B8C", bg_light: "#E6F7F9" },
  { id: 5, titulo: "Herramienta de Riesgo de Liquidez", subtitulo: "", descripcion: "Permite anticipar y monitorear posibles problemas de liquidez.", accent_color: "#B8860B", bg_light: "#FFF7E6" },
  { id: 6, titulo: "Herramienta de Riesgo Operativo", subtitulo: "", descripcion: "Permite identificar, medir y controlar los riesgos derivados de fallas en procesos.", accent_color: "#6B4FC4", bg_light: "#F0EAFF" },
];

function ProductoCard({ producto, index }) {
  return (
    <div className="rg-card" style={{
      "--accent": producto.accent_color || "#2E5AA7",
      "--bg-light": producto.bg_light || "#EAF1FF",
      animationDelay: `${index * 0.08}s`,
    }}>
      <span className="rg-card-number">{String(index + 1).padStart(2, '0')}</span>
      <div className="rg-card-accent" />
      <div className="rg-card-icon-wrap"><FiAlertTriangle size={30} /></div>
      <div className="rg-card-content">
        <p className="rg-card-subtitulo">{producto.subtitulo}</p>
        <h3 className="rg-card-titulo">{producto.titulo}</h3>
        <p className="rg-card-desc">{producto.descripcion}</p>
      </div>
      <div className="rg-card-arrow">→</div>
    </div>
  );
}

const Riesgos = () => {
  const { settings } = useSiteSettings();
    const bannerSrc = settings.banner_image
      ? `https://facach.coop.hn${settings.banner_image}`
      : fallbackBanner;

  const [productos, setProductos] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch_ = async () => {
      try {
        const res = await fetch(`${API_URL}/risk-services`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (json.ok && json.data?.length > 0) setProductos(json.data);
      } catch (err) {
        console.error("Error cargando servicios de riesgos:", err.message);
      } finally { setLoading(false); }
    };
    fetch_();
  }, []);

  return (
    <div className="riesgos-page">
      <NavbarFacach />
      <div className="banner-wrapper">
        <Image src={bannerSrc} alt="Gestión de Riesgos - FACACH" fluid className="banner-image" />
        <div className="banner-overlay">
          <h1 className="banner-title">RIESGOS</h1>
        </div>

      </div>

      <Container className="rg-section">
        <div className="rg-section-header">
          <Row className="justify-content-center">
            <Col xs={12} className="text-center">
              <h2 className="at-section-title">Sistema de Gestión Integral de Riesgos</h2>
              <p className="at-section-subtitle">
                Comprendemos que una gestión de riesgos sólida es esencial para
                garantizar la sostenibilidad y el éxito a largo plazo de las cooperativas
                afiliadas. Desde el área de Administración de Riesgos trabajamos en el
                fortalecimiento de la cultura de riesgos institucional, promoviendo la toma
                de decisiones informadas, apoyando la gestión estratégica y operativa, y
                asegurando el cumplimiento de los principios de solidez, eficiencia y
                transparencia
              </p>
            </Col>
          </Row>
        </div>

        {loading ? (
          <div className="text-center py-5" style={{ fontSize: 14, color: "#7a8aaa" }}>Cargando…</div>
        ) : (
          <div className="rg-grid">
            {productos.map((p, i) => <ProductoCard key={p.id} producto={p} index={i} />)}
          </div>
        )}

        <div className="rg-cta-wrap">
          <Button variant="primary" as={Link} to="/contacto_riesgos" className="rg-cta-btn">
            Contáctanos para obtener más información
          </Button>
        </div>
        <div className="boton-centro my-3">
          <Button as="a" href="/documentos/catalogo.pdf" target="_blank" rel="noopener noreferrer"
            variant="link" className="producto-vermas-link mt-auto p-0"
            style={{ color: "#252A58", textAlign: "center", opacity: "0.90" }}>
            Haz clic para ver nuestro Catálogo 
          </Button>
        </div>
      </Container>

      <SocialBar position="right" top="35%" size={42} rounded={true} />
      <FooterFacach />
    </div>
  );
};

export default Riesgos;